import { createTheme } from "@mui/material/styles";
import { deDE } from "@mui/material/locale";
import {
  BrandVariants,
  createLightTheme,
  createDarkTheme,
  Theme,
} from "@fluentui/react-components";

export { colors } from "./colors";
export { sizes } from "./sizes";

const theme = createTheme(
  {
    palette: {
      primary: {
        main: "#888e02",
        light: "#a0a535",
        dark: "#7a8002",
        contrastText: "#ffffff",
      },
      secondary: {
        main: "#E0E0E0",
        light: "#f8f8f8",
        dark: "#757575",
        contrastText: "#606060",
      },
      error: {
        main: "#d32f2f",
        light: "#ef5350",
        dark: "#c62828",
      },
    },
  },
  deDE
);

export default theme;

export const fluentTheme: BrandVariants = {
  10: "#040401",
  20: "#1B1A09",
  30: "#2C2C0F",
  40: "#373910",
  50: "#444510",
  60: "#505310",
  70: "#5D600F",
  80: "#6A6E0C",
  90: "#787D08",
  100: "#858B01",
  110: "#95992A",
  120: "#A5A74B",
  130: "#B5B569",
  140: "#C4C386",
  150: "#D3D2A3",
  160: "#E2E0C0",
};

export const fluentLightTheme: Theme = {
  ...createLightTheme(fluentTheme),
};

export const fluentDarkTheme: Theme = {
  ...createDarkTheme(fluentTheme),
};

fluentDarkTheme.colorBrandForeground1 = fluentTheme[110];
fluentDarkTheme.colorBrandForeground2 = fluentTheme[120];

